import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { FontAwesome } from '@fff-web/fff-ui-shared';
import { UniversalNavigationContextProvider } from '@fff-web/fff-global-nav';
import NotFoundError from './pages/NotFoundError';
import GiftCardHomePage from './pages/Gift';
import GiftConfirmation from './pages/GiftConfirmation';
import GiftCardRedemption from './pages/GiftCardRedemption';
import { addPathPrefix } from './utils/helpers';
import './App.css';

/**
 * Main App component
 * @returns {import('react').ReactNode} - React node
 */
function App() {
  return (
    <UniversalNavigationContextProvider>
      <FontAwesome />
      <Router>
        <Switch>
          <Route exact path={addPathPrefix('/gift')} component={GiftCardHomePage} />
          <Route exact path={addPathPrefix('/gift-card-confirm')} component={GiftConfirmation} />
          <Route exact path={addPathPrefix('/redeem-gift')} component={GiftCardRedemption} />
          <Route component={NotFoundError} />
        </Switch>
      </Router>
    </UniversalNavigationContextProvider>
  );
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
  options: { bootstrap: 'localStorage' },
  context: {
    kind: 'user',
    key: 'anonymous',
  },
})(App);
